import { groupNameMap } from '../../vhc/model/constants';
import { ConditionStatus } from '../../vhc/model/types';
import { getRecordCheckItemType } from '../model/utils';
import styles from '../styles.module.scss';
import {
  VHCRecordCheckBrakeItemTypesVHCRecordPartDto,
  VHCRecordCheckItemTypesVHCRecordPartDto,
  VHCRecordCheckWheelTyreItemTypesVHCRecordPartDto
} from 'api/generated';
import { useMemo } from 'react';

interface PartsProps {
  data?: {
    items:
      | (
          | VHCRecordCheckWheelTyreItemTypesVHCRecordPartDto
          | VHCRecordCheckBrakeItemTypesVHCRecordPartDto
          | VHCRecordCheckItemTypesVHCRecordPartDto
        )[]
      | null
      | undefined;
  };
  handleViewOpen: (id: number) => void;
}

export const Parts = ({ data, handleViewOpen }: PartsProps) => {
  const effectiveItems = useMemo(() => {
    const total = data && data.items && data.items?.length > 0 ? data.items : [];
    return total;
  }, [data]);

  return (
    <>
      <table className={`table ${styles.responsiveTable}`}>
        <thead>
          <tr>
            <th className={styles.hideOnMobile} scope="col">
              Source
            </th>
            <th className={styles.hideOnMobile} scope="col">
              Part Code
            </th>
            <th className={styles.hideOnMobile} scope="col">
              Part Description
            </th>
            <th className={styles.hideOnMobile} scope="col">
              Quantity
            </th>
            <th scope="col"></th>
          </tr>
        </thead>
        <tbody>
          {effectiveItems &&
            effectiveItems.map((item, index) => {
              const nameOfItem = getRecordCheckItemType(item);
              const vHCRecordItemGroup = (item as any).vHCRecordItemGroup;

              return (
                <tr key={`${index}_parts`} className={`text-black align-middle border-bottom ${styles.mobileRow}`}>
                  <td className=" text-info fw-bold">
                    {item.conditionId == ConditionStatus.WARNING && (
                      <span className={`${styles['dot']}`} style={{ background: 'rgb(220, 191, 4)' }} />
                    )}
                    {item.conditionId == ConditionStatus.NOT_OK && (
                      <span className={`${styles['dot']}`} style={{ background: 'rgb(255, 53, 8)' }} />
                    )}
                    {vHCRecordItemGroup !== undefined && groupNameMap[vHCRecordItemGroup]}-{nameOfItem}
                  </td>
                  <td className="fw-bold text-dark text-uppercase">{item.code}</td>
                  <td className="fw-bold text-dark text-uppercase">{item.description}</td>

                  <td className={styles.timeViewCell}>
                    <div className={styles.timeViewWrapper}>
                      <div>
                        <span className="fw-bold text-muted d-md-none">Quantity </span>
                        <span className="fw-bold text-dark">{item.quantity}</span>
                      </div>
                      <button className={styles.viewBtn} onClick={() => handleViewOpen(item.checkItemId!)}>
                        View
                      </button>
                    </div>
                  </td>
                </tr>
              );
            })}
        </tbody>
      </table>
    </>
  );
};
